import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['naturalSteps', 'legalSteps'];

  connect() {
    const checkedRadio = this.element.querySelector('input[name="users_profile[type]"]:checked');
    if (checkedRadio) {
      this.showStepsForType(checkedRadio.value);
    }
  }

  updateSteps(event) {
    this.showStepsForType(event.target.value);
  }

  showStepsForType(profileType) {
    if (this.hasNaturalStepsTarget) {
      this.naturalStepsTargets.forEach((naturalStep) => {
        naturalStep.classList.add('d-none');
      });
    }
    if (this.hasLegalStepsTarget) {
      this.legalStepsTargets.forEach((legalStep) => {
        legalStep.classList.add('d-none');
      });
    }

    if (profileType === 'Users::NaturalProfile' && this.hasNaturalStepsTarget) {
      this.naturalStepsTargets.forEach((naturalStep) => {
        naturalStep.classList.remove('d-none');
      });
    } else if (profileType === 'Users::LegalProfile' && this.hasLegalStepsTarget) {
      this.legalStepsTargets.forEach((legalStep) => {
        legalStep.classList.remove('d-none');
      });
    }
  }
}
